import React from 'react';
import {
  Dimensions,
  Platform,
  RefreshControl,
  SafeAreaView,
  ScrollView,
  StatusBar,
  View,
} from 'react-native';
import { COLORS } from '../../constants/theme';
import { isMd, isXl } from '../../utils/responsiveStyles';
import { HomeDashboardSection } from './HomeDashboardSection';
import { HomeHeader, HomeViewport } from './HomeHeader';
import { styles } from './HomeScreen.styles';
import { HomeScreenProps, useHomeScreen } from './useHomeScreen';

const { width } = Dimensions.get('window');

const getHomeViewport = (screenWidth: number): HomeViewport => {
  if (screenWidth >= 1024) {
    return 'desktop';
  }
  if (isXl(screenWidth)) {
    return 'tablet';
  }
  return 'mobile';
};

export const HomeScreen: React.FC<HomeScreenProps> = (props) => {
  const { state, actions } = useHomeScreen(props);
  const viewport = getHomeViewport(width);
  const isMobile = viewport === 'mobile';
  const isTablet = viewport === 'tablet';

  const {
    ownershipScope = 'group',
    onOwnershipScopeChange,
    showOwnershipScopeToggle = true,
    onLogout,
  } = props;
  const { refreshing, userData, isEditingLayout } = state;
  const { onRefresh } = actions;

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar
        barStyle="light-content"
        backgroundColor="#1F2937"
        translucent={Platform.OS === 'android'}
      />

      <ScrollView
        style={[styles.scrollContainer, !isMobile && styles.scrollContainerTablet]}
        contentContainerStyle={[styles.scrollContent, !isMobile && styles.scrollContentTablet]}
        showsVerticalScrollIndicator={false}
        bounces={true}
        refreshControl={
          isEditingLayout ? undefined : (
            <RefreshControl
              refreshing={refreshing}
              onRefresh={onRefresh}
              tintColor="#FFFFFF"
              colors={['#FFFFFF']}
              progressBackgroundColor={COLORS.primary}
              progressViewOffset={100}
            />
          )
        }
      >
        <HomeHeader
          viewport={viewport}
          userName={userData?.name}
          userEmail={userData?.email}
          ownershipScope={ownershipScope}
          onOwnershipScopeChange={onOwnershipScopeChange}
          showOwnershipScopeToggle={showOwnershipScopeToggle}
          onLogout={onLogout}
        />

        <View
          style={[
            styles.content,
            isTablet && styles.tabletContent,
            isMobile && width <= 360 && styles.content320,
            isMobile && isMd(width) && styles.tabletContent,
          ]}
        >
          <HomeDashboardSection
            screenProps={props}
            state={state}
            actions={actions}
            forceSingleColumn={isMobile}
          />
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};
